module.exports = __webpack_public_path__ + "img/33bcaefd8058d446c0c4a764f9cc1c58.d8363014.png";